import { useFormikContext } from 'formik';
import find from 'lodash/find';
import { useMemo } from 'react';
import { useUpdateEffect } from 'react-use';
import { OrgForm } from '../../../../types/entities';
import { FormData } from '../components/Wizard.type';
import { checkIsFilial } from './checkIsFilial';
import { orgTypeNames } from './getOrgTypeFlags';
import { LegalSubject } from './getOrgTypeFlags';
import { getOrgTypeFlags } from './getOrgTypeFlags';

const getNameIP = (user: {
    lastName: string;
    firstName: string;
    secondName: string;
}) => {
    return ['ИП', user.lastName, user.firstName, user.secondName]
        .filter(Boolean)
        .join(' ');
};

export const useFormOrgHook = (orgForms: Pick<OrgForm, 'id' | 'name'>[]) => {
    const { values, setValues, setTouched, setFieldValue } =
        useFormikContext<FormData>();

    const selectedOrgType = values.organization.orgType;

    const { isFL, isIP, isUL } = getOrgTypeFlags(
        selectedOrgType?.title as LegalSubject
    );

    const orgFormIP = useMemo(
        () => find(orgForms, ['name', orgTypeNames.IP]) || null,
        [orgForms]
    );

    const isFilial = useMemo(
        () =>
            !!values.organization.kpp && checkIsFilial(values.organization.kpp),
        [values.organization.kpp]
    );

    useUpdateEffect(() => {
        setFieldValue('organization.isFilial', isFilial);
    }, [isFilial]);

    useUpdateEffect(() => {
        if (isFL) {
            setValues({
                ...values,
                organization: {
                    ...values.organization,
                    orgForm: null,
                    fullName: '',
                    inn: '',
                    kpp: '',
                },
            });
        }
        if (isIP) {
            const { user, organization } = values;
            setValues({
                ...values,
                organization: {
                    ...organization,
                    orgForm: orgFormIP,
                    fullName: getNameIP(user),
                    inn: '',
                    kpp: '',
                },
            });
        }
        if (isUL) {
            const { organization } = values;
            setValues({
                ...values,
                organization: {
                    ...organization,
                    orgForm: null,
                    fullName: '',
                    inn: '',
                    kpp: '',
                },
            });
        }
        setTouched({});
    }, [isFL, isIP, isUL]);

    return { isFL, isIP, isUL, isFilial };
};
